//= =======Action Types=========

export const DASHBOARD_DATA_REQUEST = 'DASHBOARD_DATA_REQUEST';
export const DASHBOARD_DATA_SUCCESS = 'DASHBOARD_DATA_SUCCESS';
export const CASEVIEW_DATA_SUCCESS = 'CASEVIEW_DATA_SUCCESS';
export const METRICS_DATA_SUCCESS = 'METRICS_DATA_SUCCESS';
export const FILE_COUNT_SUCCESS = 'FILE_COUNT_SUCCESS';
export const DASHBOARD_SINGLE_DATA_REQUEST = 'DASHBOARD_SINGLE_DATA_REQUEST';
export const DASHBOARD_SINGLE_DATA_SUCCESS = 'DASHBOARD_SINGLE_DATA_SUCCESS';
export const DASHBOARD_DATA_FAILURE = 'DASHBOARD_DATA_FAILURE';

export const DASHBOARD_FILTER_REQUEST = 'DASHBOARD_FILTER_REQUEST';
export const DASHBOARD_FILTER_SUCCESS = 'DASHBOARD_FILTER_SUCCESS';
export const DASHBOARD_FILTER_FAILURE = 'DASHBOARD_FILTER_FAILURE';
export const DASHBOARD_SET_FILTER = 'DASHBOARD_SET_FILTER';
export const DASHBOARD_ADD_FILTER = 'DASHBOARD_ADD_FILTER';

export const DASHBOARD_RESET = 'DASHBOARD_RESET';

export const DASHBOARD_CONFIG_REQUEST = 'DASHBOARD_CONFIG_REQUEST';
export const DASHBOARD_CONFIG_SUCCESS = 'DASHBOARD_CONFIG_SUCCESS';
export const DASHBOARD_CONFIG_FAILURE = 'DASHBOARD_CONFIG_FAILURE';

export const DASHBOARD_EXPORT_REQUEST = 'DASHBOARD_EXPORT_REQUEST';
export const DASHBOARD_EXPORT_SUCCESS = 'DASHBOARD_EXPORT_SUCCESS';
export const DASHBOARD_EXPORT_FAILURE = 'DASHBOARD_EXPORT_FAILURE';

export const AREA_CONFIGURATION_REQUEST = 'AREA_CONFIGURATION_REQUEST';
export const AREA_CONFIGURATION_SUCCESS = 'AREA_CONFIGURATION_SUCCESS';
export const AREA_CONFIGURATION_FAILURE = 'AREA_CONFIGURATION_FAILURE';
export const DASHBOARD_SAVE_QUICK_TEXT = 'DASHBOARD_SAVE_QUICK_TEXT';

// reducer for shared actions
export const dashboard = (
    state = {
        loading: true,
        filters: {},
        filter: { data: {} },
        exporting: false,
    },
    action
) => {
    switch (action.type) {
        case DASHBOARD_DATA_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case DASHBOARD_SINGLE_DATA_REQUEST:
            return {
                ...state,
                [action.dataType + 'Loading']: true,
            };

        case DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                loading: action.loading,
                ...action.payload,
            };

        case CASEVIEW_DATA_SUCCESS:
            return {
                ...state,
                loading: action.loading,
                caseList: action.payload,
            };

        case METRICS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                metrics: action.payload,
            };

        case FILE_COUNT_SUCCESS:
            return {
                ...state,
                loading: action.loading,
                fileCount: action.payload,
            };

        case DASHBOARD_SINGLE_DATA_SUCCESS:
            return {
                ...state,
                [action.dataType + 'Loading']: false,
                [action.dataType]: action.payload,
            };

        case DASHBOARD_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case DASHBOARD_FILTER_REQUEST:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.filterId]: {
                        loading: true,
                        error: null,
                    },
                },
            };

        case DASHBOARD_FILTER_SUCCESS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.filterId]: {
                        loading: false,
                        values: action.payload.items.map(
                            (v) => v[action.filterId]
                        ),
                    },
                },
            };

        case DASHBOARD_FILTER_FAILURE:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.filterId]: {
                        loading: false,
                        error: action.error,
                    },
                },
            };

        case DASHBOARD_SET_FILTER:
            return {
                ...state,
                filter: {
                    data: action.payload,
                    filter_timestamp: Date.now(),
                },
            };

        case DASHBOARD_ADD_FILTER:
            return {
                ...state,
                filter: {
                    data: {
                        ...(state.filter && state.filter.data),
                        ...action.payload,
                    },
                    filter_timestamp: Date.now(),
                },
            };

        case DASHBOARD_EXPORT_REQUEST:
            return {
                ...state,
                exporting: true,
                exportError: null,
            };

        case DASHBOARD_EXPORT_SUCCESS:
            return {
                ...state,
                exporting: false,
            };

        case DASHBOARD_EXPORT_FAILURE:
            return {
                ...state,
                exporting: false,
                exportError: action.error,
            };

        case DASHBOARD_SAVE_QUICK_TEXT:
            return {
                ...state,
                quickText: action.payload,
            };

        case DASHBOARD_RESET:
            return { exporting: state.exporting };

        default:
            return state;
    }
};

export const dashboardConfig = (state = {}, action) => {
    switch (action.type) {
        case DASHBOARD_CONFIG_REQUEST:
            return {
                ...state,
                id: action.id,
                loading: true,
                error: null,
            };
        case DASHBOARD_CONFIG_SUCCESS:
            return {
                ...state,
                id: action.id,
                loading: false,
                config: action.payload,
            };
        case DASHBOARD_CONFIG_FAILURE:
            return {
                ...state,
                id: action.id,
                error: action.error,
            };
        default:
            return state;
    }
};

export const areaConfigs = (state = {}, action) => {
    switch (action.type) {
        case AREA_CONFIGURATION_REQUEST:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    loading: true,
                    error: null,
                },
            };

        case AREA_CONFIGURATION_SUCCESS:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    loading: false,
                    error: null,
                    [action.configType]: action.payload,
                },
            };

        case AREA_CONFIGURATION_FAILURE:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    loading: false,
                    error: action.error,
                },
            };

        default:
            return state;
    }
};
